export const SET_REPORTS = 'SET_REPORTS'
export const SET_REPORT = 'SET_REPORT'
export const RESET_REPORTS = 'RESET_REPORTS'
export const RESET_REPORT = 'RESET_REPORT'
